import React from 'react';
import Form from 'react-bootstrap/Form'
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Depends on values.consigneeAddress
export class ConsigneeAddress extends React.Component {
    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
        } = this.props;
        return (
            <div>
                <Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Zip</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.zip"
                                        value={values.consigneeAddress.zip}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.zip &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.zip
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.zip
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Region</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.region"
                                        value={values.consigneeAddress.region}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.region &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.region
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.region
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>City</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.city"
                                        value={values.consigneeAddress.city}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.city &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.city
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.city
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm="6">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Street</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.street"
                                        value={values.consigneeAddress.street}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.street &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.street
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.street
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>House</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.house"
                                        value={values.consigneeAddress.house}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.house &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.house
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.house
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Corpus</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.corpus"
                                        value={values.consigneeAddress.corpus}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.corpus &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.corpus
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.corpus
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Apartment</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.apartment"
                                        value={values.consigneeAddress.apartment}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.apartment &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.apartment
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.apartment
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Form.Group>
                </Form.Group>
            </div>
        );
    }
}
